// Suds2Go homepage (draft theme). Color picker swaps the hero cap and rewrites buy links to real Refillable Caps variants.
(function(){
  var dataEl=document.getElementById('s2g-variants'); if(!dataEl) return;
  var D=JSON.parse(dataEl.textContent); // {url, assets:{pink:{sm,lg}}, colors:{pink:{name,c,c2,1:id,2:id,3:id}}}
  var V=D.colors, hero=document.querySelector('.s2g .hero'), lineup=document.getElementById('heroLineup');
  var sb=document.querySelector('.s2g .sticky-buy'), hc=document.getElementById('heroCta');
  if(sb&&hc){var tick=false;function chk(){tick=false;sb.classList.toggle('show',hc.getBoundingClientRect().bottom<0);}
    window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(chk);}},{passive:true});chk();}
    function href(id){return D.url+(id?'?variant='+id:'');}
  function set(c){
    var v=V[c]; if(!v) return;
    if(hero){hero.style.setProperty('--cap',v.c);hero.style.setProperty('--cap2',v.c2);}
    if(hero) hero.dataset.color=c;
    document.querySelectorAll('.s2g .hero .sw').forEach(function(b){var on=b.dataset.c===c;b.classList.toggle('is-on',on);b.setAttribute('aria-checked',on);});
    document.querySelectorAll('.js-color-name').forEach(function(n){n.textContent=v.name;});
    // Feature the chosen cap in the lineup (others step back); default state is the mixed lineup.
    if(lineup){lineup.classList.add('has-feat');lineup.querySelectorAll('.lu').forEach(function(i){i.classList.toggle('is-feat',i.dataset.c===c);});}
    document.querySelectorAll('.s2g .js-hero-link').forEach(function(l){l.href=href(v[1]);});
  }
  document.querySelectorAll('.s2g .hero .sw').forEach(function(b){b.addEventListener('click',function(){set(b.dataset.c);});});
  var q=new URLSearchParams(location.search).get('color'); if(q) set(q);
})();
